<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main v-if="hasPage" class="Editorials">
      <h1 class="wcag-hidden">Echoes</h1>

      <Colcade class="grid" v-if="hasEditorials">
        <div class="grid-col"></div>
        <div class="grid-col"></div>
        <div class="grid-col"></div>

        <article 
          v-for="article in page.editorials"
          :key="article.url"
          class="grid-item"
        >
          <vue-link 
            :to="article.url"
            class="article"
          >
            <figure class="figure" v-if="article.gridimage">
              <img :src="article.gridimage['small-natural']" :alt="article.gridimage.alt" />
            </figure>
            <div>
              <div class="publication">{{ article.publication }}</div>
              <span class="title">{{ article.title }}</span>
            </div>
          </vue-link>
        </article>
      </Colcade>
    </main>

    <template v-slot:footer>
      <global-footer :border="true"></global-footer>
    </template>
  </layout>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import Colcade from '@/components/Colcade'

export default {
  name: 'Page',
  mixins: [ PageMixin ],
  components: { Colcade },
  computed: {
    hasEditorials () {
      return !!(this.page.editorials && this.page.editorials.length)
    }
  }
}
</script>

<style scoped>
.grid-col { 
  width: 100%; 
  float: left;
}
.grid-col:nth-child(2) { display: none; }
.grid-col:nth-child(3) { display: none; }

@media (min-width: 600px) {
  .grid-col { width: 50%; }
  .grid-col:nth-child(2) { display: block; }
}

@media (min-width: 1000px) {
  .grid-col { width: 33.33%; }
  .grid-col:nth-child(3) { display: block; }
}

.grid {
  overflow: hidden;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-bottom: 4.5rem;
}

.grid-item {
  padding: 1.5rem;
  float: left;
}

.article {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 2rem;
  background-color: black;
  color: white;
  border-radius: var(--br);
  border: 1px dashed #fff;
  font-size: 2.05rem;
}

.figure {
  padding-left: 6rem;
  padding-right: 6rem;
  margin-bottom: 2rem;
}

.figure img {
  max-height: 400px;
  max-width: 100%;
  width: auto;
  height: auto;
}

.publication {
  font: var(--nord);
  /*color: #EF3340;*/
  font-size: 1.7rem;
  text-transform: uppercase;
  margin-right: 1.4rem;
  margin-bottom: 0.5rem;
}
</style>